export default __webpack_public_path__ + "static/media/dummy2.bd2768c4.jpeg";